import { UserAccessType } from "@models/User/UserAccessType.model";
import { Event } from "@models/Event/Event.model";
import { ActionQueueLive } from "./ActionQueueLive.model";

export class ActionQueue {
   id: number;
   name: string;

   userName: string;
   userGroupName: string;
   userId: number;
   userGroupId: number;
   userAccess: UserAccessType;

   modifiedDate: Date;
   displayedOwner?: string;
   userFeatureAccess?: { [key: string] : boolean };
   
   rules: string;
   rulesObj: ActionQueueRules;

   queued: ActionQueueLive[];
   queuedWaiting: ActionQueueLive[];
   queuedHistory: ActionQueueLive[];
   queuedActive: number;

   eventIds: number[];
   saveQueueHistoryDays: number;
}

export class ActionQueueRules {
   batchSize: number = 5;
   batchReleaseCondition: string = "exactly";

   maxSimultaneousBatches: number = 1;
   batchRunTimeoutMinutes: number = 60;
   queueManualTriggers: boolean = false;
   allowDuplicateEventsInQueue: boolean = false;

   maxWaitMinutesInQueueDay: number = 60;
   maxWaitInQueueDayStartHour: number = 9;

   maxWaitMinutesInQueueNight: number = 60;
   maxWaitInQueueNightStartHour: number = 22;
}

// enum BatchSizeCondition {
//    Exactly = "exactly",
//    OrMore = "or more",
//    OrLess = "or less"
// }